import {percentage} from '../../../../assets/js/utils';
import {fileUpdate, getBatchUploadCaseInfo} from '../../../../assets/js/api';
import {BATCH_TYPE, BATCH_USER_FILE_NAME, BATCH_USER_FILE_TYPE} from '../../../../assets/js/constant';
import JiuLawUpload from '@com.thunisoft.9law/uploadSDK';
import validConst from '../../../../assets/js/validate';
import * as api from '../../../../assets/js/api';

/**
 * 匹配算法，支持快速变更匹配逻辑和规则版本
 * 后续考虑webWork处理
 */

const MatchController = {
  batchId: '',
  isSeal: false, // 调解协议上传 已签章／未签章
  // 需要统计的结果
  successList: [],
  errorList: [],
  // 匹配进度
  progress: 0,
  // 文件匹配上传过程中的文件进度统计
  allFileCount: 0, // 总计文件
  currentFileCount: 0, // 当次匹配的文件夹下文件目录总数量
  allUploadCount: 0, // 总计上传的文件（不包含案件已有文件命中）
  successFileCount: 0, // 匹配成功文件
  failFileCount: 0, // 匹配失败文件
  /**
   * 拖拽上传的匹配算法第一步
   */
  dirListIdx: 0, // 匹配到第几个目录
  conflictCaseIdx: 0, // 处理到第几个冲突的案件,默认都要从第一个开始
  /**
   * conflictData:{dirListIdx,conflictCaseIdx}
   */
  conflictCaseList: [], // 当前冲突的案件集合

  i: 0,
  j: 0,
  isKeep: false,
  lastCmd: '',
  isThrowException: false,
  currentFileMatch: {},
  matchList: [], // 阶段匹配命中数据(第一阶段+第二阶段)
  // 重启匹配用的数据
  currentFileList: [],
  currentCaseList: [],
  matchExceptionCall: null,
  drag_step_first_complete: null,

  /**
   * 拖拽上传匹配算法第二步
   * 这里使用第一阶段的matchList继续处理
   */
  uploadController: null,
  fileMatchExceptionCall: null, // 文件匹配异常抛出
  drag_step_second_complete: null, // 文件匹配结束回调
  matchIndex: 0, // 第二阶段命中案件匹配进行到了第几个
  matchCaseData: null, // 第二阶段正在匹配的案件
  fileEntryIndex: 0, // 第二阶段文件匹配中文件夹获取到第几个文件
  userIdx: 0, // 第二阶段文件匹配中匹配到了第几个用户信息

  clearAll: () => {
    MatchController.batchId = '';
    MatchController.isSeal = false;// 调解协议上传 已签章／未签章
    // 需要统计的结果
    MatchController.successList = [];
    MatchController.errorList = [];
    // 匹配进度
    MatchController.progress = 0;
    // 文件匹配上传过程中的文件进度统计
    MatchController.allFileCount = 0;// 总计文件
    MatchController.successFileCount = 0;// 匹配成功文件
    MatchController.failFileCount = 0;// 匹配失败文件
    MatchController.allUploadCount = 0;
    MatchController.currentFileCount = 0;

    /**
     * 拖拽上传的匹配算法第一步
     */
    MatchController.i = 0;
    MatchController.j = 0;
    MatchController.isKeep = false;
    MatchController.lastCmd = '';
    MatchController.isThrowException = false;
    MatchController.currentFileMatch = {};
    MatchController.matchList = [];// 阶段匹配命中数据(第一阶段+第二阶段)
    MatchController.dirListIdx = 0;
    MatchController.conflictCaseList = 0;
    MatchController.conflictCaseList = [];
    // 重启匹配用的数据
    MatchController.currentFileList = [];
    MatchController.currentCaseList = [];
    MatchController.matchExceptionCall = null;
    MatchController.drag_step_first_complete = null;
    if (MatchController.uploadController) {
      MatchController.uploadController.abort();
    }
    MatchController.uploadController = null;
    MatchController.fileMatchExceptionCall = null;// 文件匹配异常抛出
    MatchController.drag_step_second_complete = null;// 文件匹配结束回调
    MatchController.matchIndex = 0;// 第二阶段命中案件匹配进行到了第几个
    MatchController.matchCaseData = null;// 第二阶段正在匹配的案件
    MatchController.fileEntryIndex = 0;// 第二阶段文件匹配中文件夹获取到第几个文件
    MatchController.userIdx = 0;// 第二阶段文件匹配中匹配到了第几个用户信息
  },

  drag_step_first: (fileList, caseList, matchExceptionCall, complete, isContinue) => {
    MatchController.progress = 0;
    console.log('step_first', fileList, caseList);
    if (!caseList) {
      MatchController.progress = 100;
      complete(buildResult(500, '没有可匹配的案件', ''));
    }
    if (!caseList.length) {
      MatchController.progress = 100;
      complete(buildResult(500, '没有可匹配的案件', ''));
    }
    if (caseList.length <= 0) {
      MatchController.progress = 100;
      complete(buildResult(500, '没有可匹配的案件', ''));
    }
    if (fileList && fileList.length > 0) {

      /**
       * 逻辑：
       * 1。每次循环找出该文件命中的所有案件
       * 2。命中的案件之间做异常抛出处理（每次抛出两个）
       */
      MatchController.currentFileList = fileList;
      MatchController.currentCaseList = caseList;
      MatchController.matchExceptionCall = matchExceptionCall;
      MatchController.drag_step_first_complete = complete;

      while (MatchController.dirListIdx < MatchController.currentFileList.length) {
        const dirEntry = MatchController.currentFileList[MatchController.dirListIdx];
        if (dirEntry.isDirectory) {
          const dirName = dirEntry.name;
          let filterList = [];
          if (isContinue) {
            filterList = MatchController.conflictCaseList;
          } else {
            filterList = MatchController.currentCaseList.filter(caseItem => {
              return caseItem.defName.indexOf(dirName) != -1;
            });
          }

          console.log('第一阶段本次命中caseList', filterList);
          if (filterList && filterList.length > 1) {
            // 执行异常抛出
            MatchController.conflictCaseList = filterList;
            throwConflictCase(dirEntry, matchExceptionCall, complete, isContinue);
            return;
          }

          if (filterList && filterList.length == 1) {
            // 执行命中逻辑（唯一命中）
            // 最终命中的case要移出currentCaseList
            const idx = MatchController.currentCaseList.findIndex(caseItem => {
              return caseItem.mediateId == filterList[0].mediateId;
            });
            if (idx != -1) {
              MatchController.currentCaseList.splice(idx, 1);
            }
            MatchController.matchList.push(createMatchItem(dirEntry, filterList[0]));
          }
        }
        MatchController.dirListIdx++;
      }
      if (MatchController.dirListIdx >= MatchController.currentFileList.length) {
        complete(buildResult(200, '阶段一匹配完成', MatchController.matchList));
      }
    } else {
      complete(buildResult(500, '没有可匹配的文件', ''));
    }
  },

  // (cmd,keep)=>{
  //    //matchExceptionCall的回调实现
  // cmd 'skip' 跳过
  // cmd 'replace' 替换
  // keep 是否从当前指令开始，后续异常按照当前指令来统一处理(记住此操作)
  // }
  matchExceptionReceipt: (cmd, keep, throwInfo) => {
    MatchController.lastCmd = cmd;
    MatchController.isKeep = keep;
    switch (cmd) {
      case 'skip':
        break;
      case 'replace':
        cmdStepFirstReplace(throwInfo);
        break;
    }
    console.log('matchExceptionReceipt', throwInfo, MatchController.matchList);
    // 更新下一次冲突案件的匹配
    MatchController.conflictCaseIdx++;
    MatchController.drag_step_first(MatchController.currentFileList, MatchController.currentCaseList,
      MatchController.matchExceptionCall, MatchController.drag_step_first_complete, true);
  },

  /**
   *
   * @param fileMatchExceptionCall
   * @param complete
   * @param isContinue  是否抛出异常处理完成后继续进行匹配,初始化的时候是否
   * @param exceptData {fileEntryIndex,userIdx,matchFile} 异常抛出后继续执行时候的任务参数
   */
  drag_step_second: (fileMatchExceptionCall, complete, isContinue, exceptData) => {
    if (!MatchController.matchList) {
      if (complete) {
        complete(buildResult(500, '没有可匹配案件', ''));
      }
      return;
    }
    if (MatchController.matchList.length <= 0) {
      if (complete) {
        complete(buildResult(500, '没有可匹配案件', ''));
      }
      return;
    }

    if (!isContinue) {
      MatchController.matchIndex = 0;
      MatchController.lastCmd = '';
      MatchController.isKeep = false;
    }

    const matchLength = MatchController.matchList.length;
    MatchController.fileMatchExceptionCall = fileMatchExceptionCall;
    MatchController.drag_step_second_complete = complete;

    function completeFunc(isFirst) {
      if (!isFirst) {
        MatchController.matchIndex++;
      }
      if (MatchController.matchIndex < matchLength) {
        const progress = percentage(MatchController.matchIndex, matchLength);
        // if (MatchController.matchIndex == 0 || matchLength == 1) {
        //   progress = 50
        // }
        MatchController.progress = progress;
        MatchController.create_match_data(fileMatchExceptionCall, completeFunc, isContinue, exceptData);
      } else {
        MatchController.progress = 100;
        const timer = setTimeout(() => {
          if (complete) {
            complete(buildResult(200, '匹配完成', MatchController.matchCaseData));
          }
          clearTimeout(timer);
        }, 500);
      }
    }

    completeFunc(true);
  },

  /**
   * 此阶段 MatchController.matchCaseData 结构如下
   * MatchController.matchCaseData={
   *   caseData:{
          dftMatchList,
          docFiles,
        },
       fileData,
       matchData:{key:value},||key=fileType,value=matchFile,这里改造了成支持已签章和未签章的调解协议同时存在,调解协议已签章 73-t，调解协议为签章73-f
       matchUserFiles:[matchFile,...],//matchFile
   * }
   */
  /**
   * 构建第二阶段匹配所用数据
   * @param complete (控制流程是否结束的方法，上一级的completeFunc)
   */
  create_match_data: (fileMatchExceptionCall, complete, isContinue, exceptData) => {
    MatchController.matchCaseData = MatchController.matchList[MatchController.matchIndex];
    // 初始化第二阶段所需要的对象结构
    if (!MatchController.matchCaseData.matchData) {
      MatchController.matchCaseData.matchData = {};
    }
    if (!MatchController.matchCaseData.matchUserFiles) {
      MatchController.matchCaseData.matchUserFiles = [];
    }

    if (isContinue && MatchController.matchCaseData.fileEntryList) {
      // 如果是异常抛出进入的，当前异常完成匹配的数据是已经准备好的，可以直接使用
      MatchController.match_file_data(MatchController.matchCaseData.fileEntryList, fileMatchExceptionCall, complete, isContinue, exceptData);
    } else {
      const fileData = MatchController.matchCaseData.fileData;
      const caseData = MatchController.matchCaseData.caseData;

      const mediateId = caseData.mediateId;

      requestCaseInfo(mediateId, (resultData) => {
        MatchController.matchCaseData.caseData.dftMatchList = resultData.dftMatchList;
        MatchController.matchCaseData.caseData.docFiles = resultData.docFiles;
        console.log('requestCaseInfo-finish', MatchController.matchCaseData);
        readFileEntries(fileData, (fileEntryList) => {
          // 执行真正的文件匹配操作
          MatchController.matchCaseData.fileEntryList = fileEntryList;
          MatchController.match_file_data(fileEntryList, fileMatchExceptionCall, complete, false, exceptData);
        }, () => {
          complete ? complete() : '';
        });
      }, () => {
        complete ? complete() : '';
      });
    }
  },

  match_file_data: (fileEntryList, fileMatchExceptionCall, complete, isContinue, exceptData) => {
    if (isContinue) {
      MatchController.fileEntryIndex = exceptData.fileEntryIndex;
      MatchController.userIdx = exceptData.userIdx;
    } else {
      MatchController.fileEntryIndex = 0;
      MatchController.userIdx = 0;
    }

    while (MatchController.fileEntryIndex < fileEntryList.length) {
      const fileEntry = fileEntryList[MatchController.fileEntryIndex];
      if (fileEntry.isFile) {
        MatchController.currentFileCount++;
        let matchResult = matchDocFile(fileEntry, MatchController.matchCaseData, fileMatchExceptionCall);

        // 已经抛出异常需要阻断后续执行
        if (matchResult.isThrowInfo) {
          return;
        }

        if (!matchResult.isMatch) {
          matchResult = matchUserFile(fileEntry, MatchController.matchCaseData, fileMatchExceptionCall);
        }

        // 已经抛出异常需要阻断后续执行
        if (matchResult.isThrowInfo) {
          return;
        }

        MatchController.fileEntryIndex++;
      } else {
        // 文件夹直接略过
        MatchController.fileEntryIndex++;
      }
    }


    // 每次匹配完成再统计该案件下的文件匹配结果计数
    // 重新计算当前匹配成功的文件数量和失败的文件数量统计
    const successCount = getMatchFileCount();
    console.log('每次匹配完成再统计该案件下的文件匹配结果计数', MatchController.currentFileCount, successCount, MatchController.matchCaseData.matchData, MatchController.matchCaseData.matchUserFiles);
    MatchController.successFileCount += successCount;
    MatchController.failFileCount += MatchController.currentFileCount - successCount;
    MatchController.allFileCount = MatchController.currentFileCount;

    // 全部完成之后检查是否有案件已存在，但是文件夹未命中的文书和送达地址确认书，补全上传需要的参数
    checkFileMatchResult();


    // 全部完成之后执行上传任务
    MatchController.doFileUploadTask((callBackList, failList) => {
      console.log('doFileUploadTask--上传结果', callBackList, failList);
      MatchController.successList = MatchController.successList.concat(callBackList);
      MatchController.errorList = MatchController.errorList.concat(failList);
      console.log(MatchController.errorList);
      if (callBackList && callBackList.length > 0) {
        const params = createSaveParams(callBackList);
        fileUpdate({
          caseId: MatchController.matchCaseData.caseData.mediateId,
          mediateFiles: params,
        }, false).then(res => {
          // 批量匹配上传的流程完成
          complete ? complete() : '';
        }, err => {
          complete ? complete() : '';
        });
      } else {
        complete ? complete() : '';
      }
    });
  },

  matchFileExceptionReceipt: (cmd, keep, exceptData) => {
    if (keep) {
      MatchController.lastCmd = cmd;
      MatchController.isKeep = keep;
    }
    switch (cmd) {
      case 'skip':
        break;
      case 'replace':
        cmdStepSecondReplace(exceptData.matchFile);
        break;
    }
    MatchController.isThrowException = false;
    exceptData.fileEntryIndex++;
    exceptData.userIdx++;
    MatchController.drag_step_second(MatchController.fileMatchExceptionCall, MatchController.drag_step_second_complete,
      true, exceptData);
  },

  /**
   * 单个案件匹配完成之后的上传任务操作
   */
  doFileUploadTask: (complete) => {
    let completeIndex = 0;
    const callBackList = [];
    const failList = [];

    function uploadSuccess(res, matchFile) {
      callBackList.push({res, matchFile});
      console.log('    function uploadSuccess(res, matchFile) {\n', {res, matchFile});
      if (res && Object.keys(res).length > 0) {
        MatchController.allUploadCount++;
      }
      completeIndex++;
      if (completeIndex == uploadQueue.length && complete) {
        if (complete) {
          complete(callBackList, failList);
        }
        console.log('uploadSuccess', callBackList);
      }
    }

    function uploadFail(err, matchFile) {
      failList.push({
        err,
        defName: MatchController.matchCaseData.caseData.defName,
        caseNo: MatchController.matchCaseData.caseData.caseNo
      });
      completeIndex++;
      if (completeIndex == uploadQueue.length && complete) {
        if (complete) {
          complete(callBackList, failList);
        }
        console.log('uploadFail', err, failList);
      }
    }


    // 构建上传队列
    const uploadQueue = [];
    Object.keys(MatchController.matchCaseData.matchData).forEach(key => {
      const matchFile = MatchController.matchCaseData.matchData[key];
      uploadQueue.push(matchFile);
    });
    MatchController.matchCaseData.matchUserFiles.forEach(matchFile => {
      uploadQueue.push(matchFile);
    });

    console.log('uploadQueue', uploadQueue, MatchController.matchCaseData.matchData, MatchController.matchCaseData.matchUserFiles);

    if (uploadQueue.length > 0) {
      // MatchController.allUploadCount += uploadQueue.length  //包含案件已有的文件
      uploadQueue.forEach(matchFile => {
        if (matchFile.oldFile) {// 案件已上传过的文件
          uploadSuccess({}, matchFile);
        } else {
          // 真正需要上传的文件
          createUploadFile(matchFile.fileEntry, (res) => {
            if (res.code == 200 && res.data) {
              matchFile.fileEntry.file = res.data;
              MatchController.uploadRequest(matchFile, uploadSuccess, uploadFail);
            } else {
              // uploadFail
              uploadFail(`读取文件:(${matchFile.fileEntry.name})失败`, matchFile);
            }
          });
        }
      });
    } else {
      // if (complete) complete(callBackList, failList, mediateId)
      if (complete) {
        complete(callBackList, failList);
      }
    }
  },

  uploadRequest: (matchFile, success, fail) => {
    if (!MatchController.uploadController) {
      MatchController.uploadController = new JiuLawUpload({
        baseUrl: `${api.BASE_SERVER}`,
        preUrl_: '/api/v1/file/generatePresignedInfo',
        verifyFileUrl: '/api/v1/file/verifyFile',
        classType:'brtTest',
      });
    }
    // 上传前文件规范检查
    const fileEntry = matchFile.fileEntry;
    checkFileStandard(MatchController.isSeal, fileEntry, (uploadFileEntry) => {
      const fid = '';
      MatchController.uploadController.upload(
        MatchController.uploadController.createUploadParams(
          MatchController.uploadController.constant_.classType,
          uploadFileEntry.file,
          null,
          {},
          '',
        ),
        {
          transData: {
            fid,
            ft: matchFile.fileType,
          }
        },
        (res) => {
          if (res.data && (res.code == 200 || res.status == 200)) {
            // 上传成功
            if (success) {
              success(res, matchFile);
            }
          } else {
            // 上传失败
            res.msg = res.msg ? res.msg : '文件上传失败';
            if (fail) {
              fail(res.msg, matchFile);
            }
          }
        },
        (progress) => {

        }
      );
    }, (errMsg) => {
      fail(errMsg, matchFile);
    });
  },
};
export default MatchController;

const createMatchItem = (dirEntry, caseItem) => {
  return {
    fileData: dirEntry,
    caseData: caseItem,
  };
};

const throwConflictCase = (dirEntry, matchExceptionCall, complete, isContinue) => {
  if (!isContinue) {
    MatchController.conflictCaseIdx = 0;
    // 默认预设一个命中,用于跳过处理
    MatchController.matchList.push(createMatchItem(dirEntry, MatchController.conflictCaseList[0]));
    MatchController.conflictCaseList.splice(0, 1);
  }
  const lastCase = MatchController.matchList[MatchController.matchList.length - 1];
  if (MatchController.conflictCaseIdx < MatchController.conflictCaseList.length) {
    const caseData = MatchController.conflictCaseList[MatchController.conflictCaseIdx];
    // let tip = `案件：【${lastCase.caseData.caseNo}】和案件：【${caseData.caseNo}】同时命中文件夹：【${dirEntry.name}】，请处理`
    const tip = `文件夹【${dirEntry.name}】匹配到两个案件，选择跳过，保持匹配案件【${lastCase.caseData.caseNo}】；选择替换，更新匹配案件到【${caseData.caseNo}】`;
    const throwInfo = createCaseThrowInfo(tip, caseData, dirEntry);
    if (matchExceptionCall) {
      matchExceptionCall(throwInfo);
    }
  } else {
    // 进行下一个文件夹匹配
    // 最终命中的case要移出currentCaseList
    const idx = MatchController.currentCaseList.findIndex(caseItem => {
      return caseItem.mediateId == lastCase.caseData.mediateId;
    });
    if (idx != -1) {
      MatchController.currentCaseList.splice(idx, 1);
    }
    MatchController.dirListIdx++;
    MatchController.conflictCaseIdx = 0;
    MatchController.conflictData = {};
    MatchController.drag_step_first(MatchController.currentFileList, MatchController.currentCaseList,
      MatchController.matchExceptionCall, MatchController.drag_step_first_complete, false);
  }
};

const createCaseThrowInfo = (tip, conflictCase, fileEntry) => {
  return {
    dirListIdx: MatchController.dirListIdx,
    conflictCaseIdx: MatchController.conflictCaseIdx,
    tip,
    conflictCase,
    fileEntry,
  };
};

const createSaveParams = (callBackList) => {
  const batchId = MatchController.batchId;
  const paramList = [];

  /**
   * callBackList:[{res,matchFile}]
   */
  if (callBackList && callBackList.length > 0) {
    let fileParam = {};
    callBackList.forEach(data => {
      if (data.matchFile.oldFile) {
        fileParam = data.matchFile.fileInfo;
      } else {
        fileParam = {
          batchId,
          caseId: data.matchFile.caseId,
          fileName: data.res.data.fileName,
          fileSize: data.matchFile.fileEntry.file.size,
          fileSuffix: '',
          signOfficalSealFlag: MatchController.isSeal && data.matchFile.fileType == '73' ? '1' : '2',
          fileType: data.matchFile.fileType,
          ownerId: data.matchFile.userId ? data.matchFile.userId : '',
          saveId: data.res.data.fileId,
          scenesType: 3, // 这里都是案件文书
          userType: data.matchFile.userType ? data.matchFile.userType : '',
        };
      }
      paramList.push(fileParam);
    });
  }
  return paramList;
};

/**
 * 检查文件规范
 * @param isSeal
 * @param fileEntry
 * @param success
 * @param fail
 */
const checkFileStandard = (isSeal, fileEntry, success, fail) => {
  // 如果是送达地址确认书，先检查是否已经超过10个，超过的返回错误信息
  // 检查大小
  const errList = [];
  const size = fileEntry.file.size;
  if (size <= 0) {
    errList.push('文件不得为0KB');
  }
  if (size > 50 * 1024 * 1024) {
    errList.push('文件大小超过50M');
  }
  // 检查特殊字符
  const name = fileEntry.name;
  if (!validConst.legalStrIncludeSpace(name)) {
    console.log('name', name);
    errList.push('文件名称格式不对');
  }
  // 检查文件类型
  const index = name.lastIndexOf('.');
  const subfix = name.substr(index + 1).toLowerCase();
  // 增加文件是否签章判断区分文件类型
  if (isSeal) {
    subfix != 'pdf' ? errList.push('文件类型错误') : '';
  } else {
    '.word,.doc,.docx,.pdf'.indexOf(subfix) == -1 ? errList.push('文件类型错误') : '';
  }
  console.log('检查文件规范', errList, name);
  if (errList.length > 0) {
    let errMsg = `(${fileEntry.name})`;
    errList.forEach(msg => {
      errMsg += `${msg}、`;
    });
    errMsg.substr(0, errMsg.length - 2);
    if (fail) {
      fail(errMsg);
    }
  } else if (success) {
    success(fileEntry);
  }
};


const createUploadFile = (fileEntry, callBack) => {
  if (fileEntry) {
    readFile(fileEntry, (file) => {
      if (callBack) {
        callBack(buildResult(200, '获取文件成功', file));
      }
    }, (err) => {
      if (callBack) {
        callBack(buildResult(500, '获取出错', err));
      }
    });
  } else if (callBack) {
    callBack(buildResult(500, '文件对象不存在', null));
  }
};

const readFile = (fileEntry, success, err) => {
  fileEntry.file((file) => {
    console.log('readFile', file);
    if (file) {
      if (success) {
        success(file);
      }
    } else if (err) {
      err();
    }
  }, err);
};

const createMatchFile = (fileEntry, caseId, oldFile, fileInfo, userInfo, throwInfo, fileType) => {
  return {
    oldFile, // 是否已有文件
    fileInfo, // 已有文件数据对象
    fileEntry, // 文件系统文件对象
    caseId, // 案件id
    userId: userInfo ? userInfo.id : null, // 匹配的用户id
    userName: userInfo ? userInfo.name : null, // 匹配的用户名
    userType: userInfo ? userInfo.userType : null, // 匹配的用户类型（代理人／申请人／被申请人）
    throwInfo, // 抛出异常时的异常信息
    fileType, // 命中的文件类型
  };
};

const createThrowInfo = (fileEntryIndex, userIdx, defName, tip, matchFile) => {
  return {
    fileEntryIndex,
    userIdx,
    defName,
    tip,
    matchFile, // 可以替换的冲突文件
  };
};

const createMatchResult = (isMatch, matchFile, isThrowInfo) => {
  return {
    isMatch,
    isThrowInfo,
    matchFile,
  };
};

const buildResult = (code, msg, data) => {
  return {
    code: code || 500,
    data: data || '',
    msg: msg || '',
  };
};

const cmdStepFirstReplace = (throwInfo) => {
  // 当前最后一条数据被替换
  const matchItem = createMatchItem(throwInfo.fileEntry, throwInfo.conflictCase);
  const len = MatchController.matchList.length - 1;
  MatchController.matchList.splice(len, 1, matchItem);
};

const requestCaseInfo = (mediateId, success, fail) => {
  getBatchUploadCaseInfo([mediateId]).then(res => {
    if (res && res.code == 200 && res.data) {
      const data = res.data;
      const dftMatchList = [];// 被申请人及被申请人代理人相关文书的匹配+申请人及申请人代理人相关文书的匹配,根据userType区分用户角色
      let docFiles = [];// 剩余文书的匹配
      const confirmDocMap = data.confirmDocMap ? data.confirmDocMap : {};
      // 处理申请人和申请人代理人
      if (data.caseIdDftInfoMap && Object.keys(data.caseIdDftInfoMap).length > 0) {
        data.caseIdDftInfoMap[mediateId].forEach(item => {
          if (item) {// 被申请人
            dftMatchList.push({
              name: item.dftName,
              id: item.dftId,
              userType: 2, // 被申请人／被告
              //  处理所有的matchFile，打上oldFile标签
              matchFile: confirmDocMap[item.dftId] ? createMatchFile(null, mediateId, true, confirmDocMap[item.dftId][0], null, null) : null, // 需要匹配的送达文书list
            });
            if (item.dftAgentList && item.dftAgentList.length > 0) {// 被申请人代理人
              item.dftAgentList.forEach(agent => {
                if (agent) {
                  dftMatchList.push({
                    name: agent.dftAgentName,
                    id: agent.dftAgentId,
                    userType: 4, // 被申请人／被告的代理人
                    matchFile: confirmDocMap[agent.dftAgentId] ? createMatchFile(null, mediateId, true, confirmDocMap[agent.dftAgentId][0], null, null) : null, // 需要匹配的送达文书
                  });
                }
              });
            }
          }
        });
      }

      // 处理申请人和申请人代理人
      if (data.caseIdPltInfoMap && Object.keys(data.caseIdPltInfoMap).length > 0) {
        data.caseIdPltInfoMap[mediateId].forEach(item => {
          if (item) {
            dftMatchList.push({
              name: item.pltName,
              id: item.pltId,
              userType: 1, // 申请人
              matchFile: confirmDocMap[item.pltId] ? createMatchFile(null, mediateId, true, confirmDocMap[item.pltId][0], null, null) : null, // 需要匹配的送达文书
            });
            if (item.pltAgentList && item.pltAgentList.length > 0) {// 申请人代理人
              item.pltAgentList.forEach(agent => {
                dftMatchList.push({
                  name: agent.pltAgentName,
                  id: agent.pltAgentId,
                  userType: 3, // 申请人的代理人
                  matchFile: confirmDocMap[agent.pltAgentId] ? createMatchFile(null, mediateId, true, confirmDocMap[agent.pltAgentId][0], null, null) : null, // 需要匹配的送达文书
                });
              });
            }
          }
        });
      }

      /**
       * docFileList=[
       * {batchId	"39227591179173889"
             caseId	"39227591317585922"
             fileId	"40096493994627073"
             fileName	"司法确认申请书.pdf"
             fileSize	1032613
             fileSuffix	""
             fileType	"74"
             isSignature	"2"
             ownerId	""
             saveId	"40096491741712385"
             scenesType	"3"
             signOfficalSealFlag	"1"},
       ]
       */
      if (data.docFileList && data.docFileList.length > 0) {
        docFiles = data.docFileList.map(file => ({...file, oldFile: true}));
      }
      const resultData = {
        docFiles,
        dftMatchList,
      };
      console.log('requestCaseInfo', mediateId, resultData);
      success ? success(resultData) : '';
    } else {
      fail ? fail() : '';
    }
  }, err => {
    fail ? fail() : '';
  });
};

const readFileEntries = (fileData, success, fail) => {
  const dirReader = fileData.createReader();
  if (dirReader) {
    dirReader.readEntries(fileEntryList => {
      if (fileEntryList && fileEntryList.length > 0) {
        success ? success(fileEntryList) : '';
      } else {
        fail ? fail() : '';
      }
    });
  } else {
    fail ? fail() : '';
  }
};

// 其他文书匹配
const matchDocFile = (fileEntry, matchCaseData, fileMatchExceptionCall) => {
  const fileEntryName = fileEntry.name;
  const docFiles = matchCaseData.caseData.docFiles;
  // 通过变更BATCH_TYPE来支持动态配置文书类型匹配
  const matchTypeObj = BATCH_TYPE.find(item => {
    const key = Object.keys(item)[0];
    return fileEntryName.indexOf(item[key]) != -1;
  });

  if (matchTypeObj) {
    const key = Object.keys(matchTypeObj)[0];
    let matchFile = createMatchFile(fileEntry, MatchController.matchCaseData.caseData.mediateId, false, null, null, null, key);
    console.log('matchFile', matchTypeObj, matchFile, docFiles);
    if (docFiles && docFiles.length > 0) {// 检查是否和已有文件冲突
      const conflictDocFile = docFiles.find(fileItem => {
        return fileItem.fileType == key;
      });


      if (conflictDocFile) {
        // 新增逻辑，已发起签字／已盖章／已送达的文书直接命中，不参与匹配
        // 逻辑调整，如果
        /**
         * start_sign_flag varchar(2) NULL DEFAULT 2, -- 是否发起了签字：1是 2否
         * file_delivered_flag varchar(2) NULL DEFAULT 2, -- 文件是否送达：1已送达2未送达
         * signOfficalSealFlag , --1 已盖章，2未盖章
         */
        if (conflictDocFile.fileType == '73') {// 调解协议单独处理
          // 需要找到当前上传过的已签章和未签章的文书分别处理,
          //  这里整体逻辑后续可优化更少循环和内存占用的方式,已上传文书和要匹配文书均可用key|value的方式存储和处理
          let signFile = null,
            noSignFile = null;
          docFiles.forEach(item => {
            if (item.fileType == '73') {
              if (item.signOfficalSealFlag == '1') {
                signFile = item;
              } else if (item.signOfficalSealFlag == '2') {
                noSignFile = item;
              }
            }
          });
          if (MatchController.isSeal) {
            const fileDeliveredFlag = signFile ? signFile.fileDeliveredFlag == '1' : false;
            if (fileDeliveredFlag) { // 不能覆盖,已发起送达
              // 不能覆盖,已发起送达
              matchFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, signFile, null, null, key);
              MatchController.matchCaseData.matchData[`${key}t`] = matchFile; // 保存命中结果
              return createMatchResult(true, matchFile, false);
            } else {// 未发起送达但是已签章
              if (noSignFile) {
                const saveFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, noSignFile, null, null, key);
                MatchController.matchCaseData.matchData[`${key}f`] = saveFile; // 保存命中结果
              }
              if (signFile) {
                const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配已上传的文件【${signFile.fileName}】；选择替换，更新匹配新文件【${fileEntryName}】`;
                const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
                if (fileMatchExceptionCall) {
                  fileMatchExceptionCall(exceptData);
                }
                return createMatchResult(false, null, true);
              }
            }
          } else {
            let fileDeliveredFlag = noSignFile ? noSignFile.fileDeliveredFlag == '1' : false,
              start_sign_flag = noSignFile ? noSignFile.startSignFlag == '1' : false;
            if (signFile) {
              const saveFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, signFile, null, null, key);
              MatchController.matchCaseData.matchData[`${key}t`] = saveFile; // 保存命中结果
            }
            if (noSignFile) {
              if (start_sign_flag || fileDeliveredFlag) { // 不能覆盖
                const saveFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, noSignFile, null, null, key);
                MatchController.matchCaseData.matchData[`${key}f`] = saveFile; // 保存命中结果
                return createMatchResult(true, saveFile, false);
              } else {
                const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配已上传的文件【${noSignFile.fileName}】；选择替换，更新匹配新文件【${fileEntryName}】`;
                const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
                if (fileMatchExceptionCall) {
                  fileMatchExceptionCall(exceptData);
                }
                return createMatchResult(false, null, true);
              }
            }
          }
        } else if (conflictDocFile.startSignFlag == '1' ||
          conflictDocFile.fileDeliveredFlag == '1' ||
          conflictDocFile.signOfficalSealFlag == '1') {
          matchFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, conflictDocFile, null, null, key);
          MatchController.matchCaseData.matchData[key] = matchFile; // 保存命中结果
          return createMatchResult(true, matchFile, false);
        } else {
          // 抛出异常，构建异常处理信息
          // let tip = `案件【${matchCaseData.caseData.caseNo}】已上传的文件【${conflictDocFile.fileName}】与匹配文件【${fileEntryName}】发生重复，请处理`
          const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配已上传的文件【${conflictDocFile.fileName}】；选择替换，更新匹配新文件【${fileEntryName}】`;

          const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
          if (fileMatchExceptionCall) {
            fileMatchExceptionCall(exceptData);
          }
          return createMatchResult(false, null, true);
        }
      }
    }

    if (matchCaseData.matchData && matchCaseData.matchData[key] && !matchCaseData.matchData[key].oldFile) {// 检查是否和之前命中的同类型文件冲突
      // 抛出异常，构建异常处理信息
      const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配的文件【${matchCaseData.matchData[key].fileEntry.name}】；选择替换，更新匹配文件【${fileEntryName}】`;
      const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
      if (fileMatchExceptionCall) {
        fileMatchExceptionCall(exceptData);
      }
      return createMatchResult(false, null, true);
    } else if (matchCaseData.matchData && matchCaseData.matchData['73t'] && !matchCaseData.matchData['73t'].oldFile && key == '73') {
      const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配的文件【${matchCaseData.matchData['73t'].fileEntry.name}】；选择替换，更新匹配文件【${fileEntryName}】`;
      const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
      if (fileMatchExceptionCall) {
        fileMatchExceptionCall(exceptData);
      }
      return createMatchResult(false, null, true);
    } else if (matchCaseData.matchData && matchCaseData.matchData['73f'] && !matchCaseData.matchData['73f'].oldFile && key == '73') {
      const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配的文件【${matchCaseData.matchData['73f'].fileEntry.name}】；选择替换，更新匹配文件【${fileEntryName}】`;
      const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
      if (fileMatchExceptionCall) {
        fileMatchExceptionCall(exceptData);
      }
      return createMatchResult(false, null, true);
    }

    // 最终匹配成功,这里的命中是可以计数展示的
    // MatchController.successFileCount++
    // 区分调解协议是否签章分别保存
    if (key == '73') {
      if (MatchController.isSeal) {
        MatchController.matchCaseData.matchData[`${key}t`] = matchFile; // 保存命中结果
      } else {
        MatchController.matchCaseData.matchData[`${key}f`] = matchFile; // 保存命中结果
      }
    } else {
      MatchController.matchCaseData.matchData[key] = matchFile; // 保存命中结果
    }
    return createMatchResult(true, matchFile, false);
  } else {
    return createMatchResult(false, null, false);
  }
};

// 申请人／被申请人／代理人相关送达地址确认书匹配
const matchUserFile = (fileEntry, matchCaseData, fileMatchExceptionCall) => {
  const fileEntryName = fileEntry.name;
  const dftMatchList = matchCaseData.caseData.dftMatchList;
  const key = BATCH_USER_FILE_TYPE;
  const matchName = BATCH_USER_FILE_NAME;

  if (fileEntryName.indexOf(matchName) != -1) {
    // 检查是否和已有文件冲突
    if (dftMatchList && dftMatchList.length > 0) {
      let matchFileEntryName = fileEntryName;
      matchFileEntryName = matchFileEntryName ? matchFileEntryName.replace('－', '-') : matchFileEntryName;
      matchFileEntryName = matchFileEntryName ? matchFileEntryName.replace('——', '-',) : matchFileEntryName;
      matchFileEntryName = matchFileEntryName ? matchFileEntryName.replace(' - ', '-') : matchFileEntryName;
      const index = matchFileEntryName.lastIndexOf('.');
      matchFileEntryName = index > 0 ? matchFileEntryName.substr(0, index) : matchFileEntryName;
      const splitStrArr = matchFileEntryName.split('-');
      const splitFileEntryName = splitStrArr && splitStrArr.length > 0 ? splitStrArr[splitStrArr.length - 1] : '';
      const dftUser = dftMatchList.find(dftUser => {
        return splitFileEntryName == dftUser.name && dftUser.name != '';
      });
      console.log('当前匹配送达地址确认书的文件：', fileEntryName, '命中的被告：', dftUser ? dftUser.name : '', dftUser);
      if (dftUser && dftUser.name && dftUser.matchFile) {// 有冲突
        const matchFile = createMatchFile(fileEntry, MatchController.matchCaseData.caseData.mediateId, false, null, dftUser, null, key);

        // 需要处理能否覆盖,如果不能覆盖，构造matchFile对象返回(已送达、已发起签字的不能覆盖)
        /**
         * start_sign_flag varchar(2) NULL DEFAULT 2, -- 是否发起了签字：1是 2否
         * file_delivered_flag varchar(2) NULL DEFAULT 2, -- 文件是否送达：1已送达2未送达
         */
        if (dftUser.matchFile.fileInfo) {
          // 匹配成功,这里的命中是已有文件不可能变更的命中，不需要计数
          if (dftUser.matchFile.fileInfo.fileDeliveredFlag == '1' || dftUser.matchFile.fileInfo.isSignature == '1' || dftUser.matchFile.fileInfo.startSignFlag == '1') {
            const matchFile = createMatchFile(null, MatchController.matchCaseData.caseData.mediateId, true, dftUser.matchFile.fileInfo, dftUser, null, key);
            MatchController.matchCaseData.matchUserFiles.push(matchFile); // 保存命中结果
            return createMatchResult(true, matchFile, false);
          }
          const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配已上传的文件【${dftUser.matchFile.fileInfo.fileName}】；选择替换，更新匹配文件【${fileEntryName}】`;
          const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
          if (fileMatchExceptionCall) {
            fileMatchExceptionCall(exceptData);
          }
          return createMatchResult(false, null, true);
        } else {
          // 这个逻辑也是命中
          // MatchController.successFileCount++
          MatchController.matchCaseData.matchUserFiles.push(matchFile); // 保存命中结果
          return createMatchResult(true, matchFile, false);
        }
      } else if (dftUser && dftUser.name) {
        const conflictFile = matchCaseData.matchUserFiles.find(item => {
          return item.userId == dftUser.id && item.fileType == key;
        });
        const matchFile = createMatchFile(fileEntry, MatchController.matchCaseData.caseData.mediateId, false, null, dftUser, null, key);

        if (conflictFile) {// 和已命中有冲突
          const tip = `案件【${matchCaseData.caseData.caseNo}】匹配到两个文件，选择跳过，保持匹配的文件【${conflictFile.fileEntry.name}】；选择替换，更新匹配文件【${fileEntryName}】`;
          const exceptData = createThrowInfo(MatchController.fileEntryIndex, MatchController.userIdx, '', tip, matchFile);
          if (fileMatchExceptionCall) {
            fileMatchExceptionCall(exceptData);
          }
          return createMatchResult(false, null, true);
        } else {// 命中
          // 最终匹配成功,这里的命中是可以计数展示的
          // MatchController.successFileCount++
          MatchController.matchCaseData.matchUserFiles.push(matchFile); // 保存命中结果
          return createMatchResult(true, matchFile, false);
        }
      } else {// 未命中
        return createMatchResult(false, null, false);
      }
    } else {// 未命中
      return createMatchResult(false, null, false);
    }
  } else {// 未命中
    return createMatchResult(false, null, false);
  }
};


const checkFileMatchResult = () => {
  const caseId = MatchController.matchCaseData.caseData.mediateId;
  const docFiles = MatchController.matchCaseData.caseData.docFiles;
  const dftMatchList = MatchController.matchCaseData.caseData.dftMatchList;
  const matchData = MatchController.matchCaseData.matchData;
  const matchUserFiles = MatchController.matchCaseData.matchUserFiles;

  // 检查其他类型文书,并补全已有文书
  if (docFiles.length > 0) {
    docFiles.forEach(fileItem => {
      const key = fileItem.fileType;
      if (key == '73') {
        let sign = '73t',
          noSign = '73f',
          fileIsSign = fileItem.signOfficalSealFlag == '1';
        if (fileIsSign) {
          if (!matchData[sign]) {
            MatchController.matchCaseData.matchData[sign] = createMatchFile(null, caseId, true, fileItem, null, null, key);
          }
        } else if (!matchData[noSign]) {
          MatchController.matchCaseData.matchData[noSign] = createMatchFile(null, caseId, true, fileItem, null, null, key);
        }
      } else if (!matchData[key]) {// 证明丢了一个已经上传本地文书
        MatchController.matchCaseData.matchData[key] = createMatchFile(null, caseId, true, fileItem, null, null, key);
      }
    });
  }

  // 检查送达地址确认书
  dftMatchList.forEach(dftUser => {
    if (dftUser.matchFile) {
      const target = matchUserFiles.find(userFiles => {
        return userFiles.userId == dftUser.id;
      });
      if (!target) {// 需要把已有送达地址确认书补全
        const matchFile = createMatchFile(null, caseId, true, dftUser.matchFile.fileInfo,
          dftUser, null, dftUser.matchFile.fileInfo.fileType);
        MatchController.matchCaseData.matchUserFiles.push(matchFile);
      }
    }
  });
};

const cmdStepSecondReplace = (matchFile) => {
  // 需要根据是其他文书还是送达文书来处理
  console.log('cmdStepSecondReplace', matchFile);
  if (matchFile.fileType == BATCH_USER_FILE_TYPE) {// 送达地址确认书
    const index = MatchController.matchCaseData.matchUserFiles.findIndex(fileItem => {
      return fileItem.userId == matchFile.userId;
    });
    if (index != -1) {
      MatchController.matchCaseData.matchUserFiles.splice(index, 1, matchFile);
    } else {
      MatchController.matchCaseData.matchUserFiles.push(matchFile);
    }
  } else {// 其他文书
    console.log(MatchController.matchCaseData.caseData.docFiles);
    // 如果是调解协议，需要根据当前选中是否签章来处理
    if (matchFile.fileType == '73') {
      const key = MatchController.isSeal ? '73t' : '73f';
      MatchController.matchCaseData.matchData[key] = matchFile;
      // bugfix-9965--docFiles == object
      const spliceIndex = MatchController.matchCaseData.caseData.docFiles.findIndex(docFile => {
        if (docFile.fileType == '73') {
          if (MatchController.isSeal) {
            return docFile.signOfficalSealFlag == '1';
          } else {
            return docFile.signOfficalSealFlag == '2';
          }
        }
      });
      if (spliceIndex != -1) {
        MatchController.matchCaseData.caseData.docFiles.splice(spliceIndex, 1);
      }
    } else {
      MatchController.matchCaseData.matchData[matchFile.fileType] = matchFile;
      // bugfix-9965
      const spliceIndex = MatchController.matchCaseData.caseData.docFiles.findIndex(docFile => {
        return docFile.fileType == matchFile.fileType;
      });
      if (spliceIndex != -1) {
        MatchController.matchCaseData.caseData.docFiles.splice(spliceIndex, 1);
      }
    }
  }
};

/**
 * 统计匹配成和失败的数量（当次案件）
 */
const getMatchFileCount = () => {
  let lenData = 0,
    lenUserData = 0;
  if (MatchController.matchCaseData.matchData) {
    Object.keys(MatchController.matchCaseData.matchData).forEach(key => {
      if (!MatchController.matchCaseData.matchData[key].oldFile) {
        lenData++;
      }
    });
  }
  if (MatchController.matchCaseData.matchUserFiles) {
    MatchController.matchCaseData.matchUserFiles.forEach(item => {
      if (!item.oldFile) {
        lenUserData++;
      }
    });
  }
  return lenData + lenUserData;
};
